
const AWSurl = {};
const api = {};
if (process.env.VUE_APP_UserManagementDomain == null) {
  api.userManagementDomain = 'https://digitlogisticauthentication-spim-fashion-development.up.railway.app/api/v1';
  api.logisticStoreData = 'https://digitlogisticstoredata-spim-fashion-development.up.railway.app/api/v1';
  api.tourManagement = 'https://digitlogistictourmanagement-spim-fashion-development.up.railway.app/api/v1';
  api.tourManagementForNotification = 'https://digitlogistictourmanagement-spim-fashion-development.up.railway.app';
  api.vacation = 'https://railwdevvacationmanagement.digitwebsite.ch/api/v1/4F5EF963-2335-43DC-3ECC-08DC3C4B89FA';

  api.countryId = '9080b1da-4da4-4b25-5c93-08db31f6edb2';


  AWSurl.bucketName = 'spim-file-development';
  AWSurl.accessKeyId = 'AKIAZN2PMAGNIXQ74O4R';
  AWSurl.secretAccessKey = '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';
  AWSurl.region = 'eu-central-1';
} else {
  api.userManagementDomain = process.env.VUE_APP_UserManagementDomain;
  api.logisticStoreData = process.env.VUE_APP_StoreDataDomain;
  api.tourManagement = process.env.VUE_APP_TourManagementDomain;
  api.tourManagementForNotification = process.env.VUE_APP_TourManagementForNotificationDomain;
  api.vacation = process.env.VUE_APP_VacationDomain;
  api.countryId = process.env.VUE_APP_countryId;



  AWSurl.bucketName = process.env.VUE_APP_bucketName;
  AWSurl.accessKeyId = process.env.VUE_APP_accessKeyId;
  AWSurl.secretAccessKey = process.env.VUE_APP_secretAccessKey;
  AWSurl.region = process.env.VUE_APP_region;
}

module.exports = {
  api,
  AWSurl,
};
